import {ApplicationContextConfig} from './application-context.service';
import {ApplicationContext, ApplicationContextUrlParamValue} from '../../../consts/application-context.enum';
import {StepKey} from '../../../enums/step-key.enum';
import {PaymentMethod} from '../../../consts/payment-method.enum';
import {NextBannerConfig} from '../../../models/next-banners-config';
import {SalesChannel} from '../../../consts/sales-channel.enum';
import {env} from '../../../utils/utils';
import {RuntimeEnvironment} from '../../../../shared/enums/runtime-environment.enum';
import {SectionComponentKey} from '../../../enums/components-keys';

export class ApplicationContextsConfigBuilder {

    private partnerDefined: boolean;
    private DIAGNOSTIC_STATION_BANNER: NextBannerConfig = {
        title: 'DIAGNOSTIC_STATION_BANNER.TITLE',
        subtitle: 'DIAGNOSTIC_STATION_BANNER.SUBTITLE',
        imageSrc: './assets/images/banner-diagnostic-station.png',
        cssClassSuffix: 'diagnostic-station'
    };

    constructor(partnerDefined: boolean) {
        this.partnerDefined = partnerDefined;
    }

    createConfig(): ApplicationContextConfig[] {
        return [
            {
                context: ApplicationContext.DIAGNOSTIC_STATION,
                urlParamValue: ApplicationContextUrlParamValue.DIAGNOSTIC_STATION,
                salesChannels: [
                    SalesChannel.KIOSKPOLIS
                ],
                navigationHidden: true,
                sendOfferHidden: true,
                submitGoogleReviewHidden: true,
                steps: [
                    {
                        stepKey: StepKey.FIRST_STEP_0,
                        disabledSections: [
                            SectionComponentKey.CALCULATIONS_CACHE,
                            SectionComponentKey.ADDITIONAL_DATA,
                            SectionComponentKey.SALES_MESSAGES,
                            SectionComponentKey.ADDITIONAL_CONTENT,
                            SectionComponentKey.CALCULATION_AGREEMENTS,
                        ],
                        banner: this.DIAGNOSTIC_STATION_BANNER
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_1,
                        disabledSections: [

                        ],
                        banner: this.DIAGNOSTIC_STATION_BANNER
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_2,
                        disabled: true
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_3,
                        disabledSections: [
                            SectionComponentKey.OWNER_DATA,
                            SectionComponentKey.DISCOUNT_CODES,
                        ],
                        buttonLabel: 'forwardContact',
                        banner: this.DIAGNOSTIC_STATION_BANNER
                    },
                    {
                        stepKey: StepKey.SECOND_STEP,
                        disabled: true
                    },
                    {
                        stepKey: StepKey.THIRD_STEP,
                        disabled: true
                    }
                ],
                calculationEmailRequired: false,
                defaultCalculationEmail: 'stacje_mail@kioskpolis.pl',
                calculationPhoneNumberRequired: true,
                thuliumWidgetHidden: true,
                headerLogoRedirectDisabled: true,
            },
            {
                context: ApplicationContext.AGENT,
                urlParamValue: ApplicationContextUrlParamValue.AGENT,
                salesChannels: [
                    SalesChannel.KIOSKPOLIS
                ],
                steps: [
                    {
                        stepKey: StepKey.FIRST_STEP_0,
                        disabledSections: [
                            SectionComponentKey.CALCULATIONS_CACHE,
                        ],
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_1,
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_2,
                    },
                    {
                        stepKey: StepKey.FIRST_STEP_3,
                    },
                    {
                        stepKey: StepKey.THIRD_STEP,
                    },
                ],
                calculationEmailRequired: false,
                calculationPhoneNumberVisible: false,
                submitGoogleReviewHidden: true,
                allowedPaymentMethods: [
                    PaymentMethod.BLIK,
                    PaymentMethod.ONLINE_TRANSFER,
                    PaymentMethod.CARD,
                ],
                thuliumWidgetHidden: true,
                headerLogoRedirectDisabled: true,
                headerTitle: this.partnerDefined ? 'HEADER.AGENT_TITLE' : undefined,
                headerTitleBadge: this.partnerDefined ? './assets/images/icons/affiliate-program-badge.svg' : undefined,
                disabledAgreements: [
                    'MARKETING_AGREEMENT'
                ],
                calculationsCacheDisabled: true
            },
            {
                context: ApplicationContext.AGENT_MOBILE,
                urlParamValue: ApplicationContextUrlParamValue.AGENT_MOBILE,
                salesChannels: env() === RuntimeEnvironment.PROD ? [] : [
                    SalesChannel.KIOSKPOLIS
                ],
                calculationEmailRequired: true,
                calculationPhoneNumberRequired: false,
                submitGoogleReviewHidden: true,
                allowedPaymentMethods: [
                    PaymentMethod.BLIK,
                    PaymentMethod.TAP_ON_MOBILE,
                ],
                thuliumWidgetHidden: true,
                headerLogoRedirectDisabled: true,
            }
        ];
    }
}
